import { PublicClientApplication } from '@azure/msal-browser';

const azureClientId =
  import.meta.env.VITE_AZURE_CLIENT_ID ||
  '51bc9166-9c68-47c2-a948-6a08370227ca';

// Use explicit localhost redirect URI for localhost (for e2e tests and local dev)
// Otherwise dynamically use the current origin (works for any deployed hostname)
const isLocalhost = window.location.hostname === 'localhost';
const redirectUri = isLocalhost
  ? 'http://localhost:4200/map'
  : `${window.location.origin}/map`;

// Check if we're in a secure context (HTTPS), localhost is considered secure
const isHttps =
  window.location.protocol === 'https:' ||
  window.location.hostname === 'localhost';

export const msalConfig = {
  auth: {
    clientId: azureClientId,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = isHttps
  ? new PublicClientApplication(msalConfig)
  : null;

export const loginRequest = {
  scopes: ['User.Read'],
};
